module.exports = __webpack_public_path__ + "e873a7ab95eee2717458af8432636abd.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=900!./src/components/cover/teaser.jpg?size=900w
// module id = 33
// module chunks = 1